// extracted by mini-css-extract-plugin
export default {"download":"VbcB48WPAT5sYupjy8iL","view":"PoatLrYry2R9NG8X15et"};